(() => {
  class AVDMegaHeader {
    constructor(root) {
      this.root = root;
      this.items = [...root.querySelectorAll('[data-avd-nav-item]')];
      this.mobile = root.querySelector('[data-avd-mobile]');
      this.openBtn = root.querySelector('[data-avd-mobile-open]');
      this.closeBtns = [...root.querySelectorAll('[data-avd-mobile-close]')];
      this.activeItem = null;
      this.closeTimer = null;
      this.bindDesktop();
      this.bindMobile();
      this.bindGlobal();
    }

    bindDesktop() {
      this.items.forEach((item) => {
        const trigger = item.querySelector('[data-avd-trigger]');
        if (!trigger) return;
        const open = () => this.openItem(item);
        const delayedClose = () => this.queueClose(item);
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', delayedClose);
        trigger.addEventListener('focus', open);
        trigger.addEventListener('click', (event) => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            return;
          }
          event.preventDefault();
          this.openMobile(trigger.dataset.avdMobileTarget);
        });
      });

      this.root.addEventListener('click', (event) => {
        const cartBubble = event.target.closest('#cart-icon-bubble');
        if (!cartBubble) return;
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        event.preventDefault();
        cartDrawer.open(cartBubble);
      });
    }

    bindMobile() {
      if (!this.mobile || !this.openBtn) return;
      this.openBtn.addEventListener('click', () => this.openMobile());
      this.closeBtns.forEach((btn) => btn.addEventListener('click', () => this.closeMobile()));

      const mainPanel = this.mobile.querySelector('[data-avd-mobile-panel-main]');
      const subPanel = this.mobile.querySelector('[data-avd-mobile-panel-sub]');
      const subTitle = this.mobile.querySelector('[data-avd-mobile-sub-title]');

      if (mainPanel) {
        mainPanel.addEventListener('click', (event) => {
          const pageBtn = event.target.closest('[data-avd-mobile-page]');
          if (!pageBtn) return;
          if (pageBtn.dataset.avdMobileHasSub !== 'true') return;
          event.preventDefault();
          const title = pageBtn.dataset.avdMobilePage;
          const pageContent = this.mobile.querySelector(`[data-avd-mobile-page-content="${title}"]`);
          if (!pageContent) return;
          this.mobile.querySelectorAll('[data-avd-mobile-page-content]').forEach((page) => {
            page.hidden = page !== pageContent;
          });
          subTitle.textContent = pageBtn.querySelector('span')?.textContent || '';
          this.mobile.classList.add('is-sub-open');
          if (subPanel) subPanel.setAttribute('aria-hidden', 'false');
          const subBody = subPanel?.querySelector('[data-avd-mobile-sub-body]');
          if (subBody) subBody.scrollTop = 0;
        });
      }

      const backBtn = this.mobile.querySelector('[data-avd-mobile-back]');
      if (backBtn) {
        backBtn.addEventListener('click', () => {
          this.mobile.classList.remove('is-sub-open');
          if (subPanel) subPanel.setAttribute('aria-hidden', 'true');
        });
      }

      this.mobile.querySelectorAll('[data-avd-mobile-link]').forEach((link) => {
        link.addEventListener('click', () => this.closeMobile());
      });

      const searchTrigger = this.mobile.querySelector('[data-avd-search-trigger]');
      if (searchTrigger) {
        searchTrigger.addEventListener('click', () => {
          this.closeMobile();
          const headerSearch = this.root.querySelector('.header__search > details');
          if (headerSearch) {
            headerSearch.open = true;
            const input = headerSearch.querySelector('input[type="search"]');
            if (input) setTimeout(() => input.focus(), 100);
          }
        });
      }

      const cartTrigger = this.mobile.querySelector('[data-avd-cart-trigger]');
      if (cartTrigger) {
        cartTrigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.closeMobile();
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) cartDrawer.open(cartTrigger);
        });
      }
    }

    bindGlobal() {
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          this.closeAll();
          this.closeMobile();
        }
      });
      document.addEventListener('click', (event) => {
        if (!this.root.contains(event.target)) this.closeAll();
      });
    }

    openItem(item) {
      clearTimeout(this.closeTimer);
      this.items.forEach((other) => {
        if (other !== item) this.closeItem(other);
      });
      item.classList.add('is-open');
      const trigger = item.querySelector('[data-avd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      this.activeItem = item;
    }

    closeItem(item) {
      item.classList.remove('is-open');
      const trigger = item.querySelector('[data-avd-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (this.activeItem === item) this.activeItem = null;
    }

    queueClose(item) {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeItem(item), 140);
    }

    closeAll() {
      this.items.forEach((item) => this.closeItem(item));
    }

    openMobile(activeTitle = null) {
      this.mobile.classList.add('is-open');
      this.mobile.classList.remove('is-sub-open');
      this.mobile.setAttribute('aria-hidden', 'false');
      this.openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';

      const subPanel = this.mobile.querySelector('[data-avd-mobile-panel-sub]');
      if (subPanel) subPanel.setAttribute('aria-hidden', 'true');
      this.mobile.querySelectorAll('[data-avd-mobile-page-content]').forEach((page) => {
        page.hidden = true;
      });

      if (activeTitle) {
        const pageBtn = this.mobile.querySelector(`[data-avd-mobile-page="${activeTitle}"]`);
        if (pageBtn) pageBtn.click();
      }
    }

    closeMobile() {
      if (!this.mobile) return;
      this.mobile.classList.remove('is-open', 'is-sub-open');
      this.mobile.setAttribute('aria-hidden', 'true');
      this.openBtn && this.openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      const subPanel = this.mobile.querySelector('[data-avd-mobile-panel-sub]');
      if (subPanel) subPanel.setAttribute('aria-hidden', 'true');
      this.mobile.querySelectorAll('[data-avd-mobile-page-content]').forEach((page) => {
        page.hidden = true;
      });
    }
  }

  const init = () => {
    document.querySelectorAll('[data-avd-header]').forEach((root) => {
      if (root.dataset.avdReady) return;
      root.dataset.avdReady = 'true';
      new AVDMegaHeader(root);
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
